import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiPhone, FiMail } = FiIcons;

const Hero = () => {
  return (
    <section id="home" className="pt-16 bg-gradient-to-br from-blue-50 to-white min-h-screen flex items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Professional{' '}
              <span className="text-blue-600">Bookkeeping</span>{' '}
              Services
            </h1>
            <p className="mt-6 text-xl text-gray-600 leading-relaxed">
              Expert financial management for your business by Sue Rodriguez, Certified QuickBooks Pro Advisor. Let us handle your books while you focus on growing your business.
            </p>

            {/* Key Features */}
            <div className="mt-8 space-y-4">
              {[
                'Certified QuickBooks Pro Advisor',
                'Accurate Financial Records',
                'Tax Preparation Support',
                'Monthly Financial Reports'
              ].map((feature, index) => (
                <motion.div
                  key={feature}
                  className="flex items-center space-x-3"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500" />
                  <span className="text-gray-700 font-medium">{feature}</span>
                </motion.div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <motion.a
                href="#contact"
                className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 text-center"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Get Started Today
              </motion.a>
              <motion.a
                href="tel:407-697-6563"
                className="bg-white border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors duration-200 text-center flex items-center justify-center gap-2"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <SafeIcon icon={FiPhone} className="h-5 w-5" />
                Call Now
              </motion.a>
            </div>
          </motion.div>

          {/* Image/Visual */}
          <motion.div
            className="relative"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 shadow-2xl">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="flex items-center gap-4 mb-4">
                  <h3 className="text-2xl font-bold text-gray-900">
                    Sue Rodriguez
                  </h3>
                  <div className="w-16 h-16 relative flex-shrink-0">
                    <img 
                      src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752510277763-Pro%20Advisor.png"
                      alt="QuickBooks Pro Advisor Badge"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
                <p className="text-blue-600 font-semibold mb-4">
                  Certified QuickBooks Pro Advisor
                </p>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiMail} className="h-5 w-5 text-blue-600" />
                    <span className="text-gray-700">bookkeeper@wisdomwaresllc.com</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiPhone} className="h-5 w-5 text-blue-600" />
                    <span className="text-gray-700">407-697-6563</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;